const prefix = "[GENERAL]";

export default {
    ERROR: `${prefix} ERROR`,
    DISPLAY_ERROR: `${prefix} DISPLAY_ERROR`,
    RESET_UNHANDLED_ERROR: `${prefix} RESET_UNHANDLED_ERROR`,
    RESET_API_ERROR: `${prefix} RESET_API_ERROR`,
    FINISH_FORM_SUBMIT: `${prefix} FINISH_FORM_SUBMIT`,
};
